import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ImageButtonList from '../common/imageButtonList';
import ImageText from '../common/imageText';
import popup from './images/Multilingual_popup.png';
import englishUH from './images/Multilingual_English_UH.png';
import englishHL from './images/Multilingual_English_HL.png';
import spanishUH from './images/Multilingual_Espanol_UH.png';
import spanishHL from './images/Multilingual_Espanol_HL.png';

class MultilingualSelection extends Component {
  /**************
   * Properties *
   **************/
  state = {
    buttons: [
      {
        id: 'english',
        to: this.buildLink(),
        highlight: englishHL,
        unhighlight: englishUH,
        alt: 'English'
      },
      {
        id: 'spanish',
        to: this.buildLink(),
        highlight: spanishHL,
        unhighlight: spanishUH,
        alt: 'Espanol'
      }
    ]
  };

  buildLink() {
    let linkRoute = '';
    if (this.props.videoName === 'angiography') {
      linkRoute = `/assigned_education/${this.props.videoName}/comprehension`;
    } else {
      linkRoute = `/assigned_education/${this.props.videoName}/prescribed_education`;
    }
    return linkRoute;
  };

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns { React.Component }  The rendered view of the component.
   *
   */
  render() {
    return (
      <div className="multilingual-selection">
        <ImageText src={popup} />
        <ImageButtonList imageButtons={this.state.buttons} />
      </div>
    );
  }
}

export default withRouter(MultilingualSelection);
